import { render, staticRenderFns } from "./AddInternalCommentToLoansModal.vue?vue&type=template&id=56c91354"
import script from "./AddInternalCommentToLoansModal.ts?vue&type=script&lang=ts&external"
export * from "./AddInternalCommentToLoansModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c91354')) {
      api.createRecord('56c91354', component.options)
    } else {
      api.reload('56c91354', component.options)
    }
    module.hot.accept("./AddInternalCommentToLoansModal.vue?vue&type=template&id=56c91354", function () {
      api.rerender('56c91354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/AddInternalCommentToLoansModal.vue"
export default component.exports